<template>
  <v-app>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" to="/login">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width:40%"><img v-bind:src="logo.src" :height="logo.height"  alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Statement Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.paystatementnum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.paystatementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                    <tr>
                      <td colspan="3"><div align="center"><h3 class="ma-0"><b>{{ initvalue.paystatementtype }}</b></h3></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text" cols="12">
                  <v-col cols="12">
                  
                  </v-col>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr>
                      <td style="width: 45%; vertical-align: text-top">
                        <div>
                          <span style="font-size: 11pt; font-weight: bold">EMPLOYEE:</span>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.paystatementname }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;white-space: pre-wrap">{{ initvalue.paystatementaddress }}</p>
                        </div>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                        <table  style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Period Start</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date( getServerDate( initvalue.paystatementstartdate ) ).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Period End</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(initvalue.paystatementenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Payment Method</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.paymethod }}</span></td>
                          </tr>
                          <tr v-if="isDualCurrency==true">
                            <td><span style="font-size: 11pt; font-weight: bold">Currency Rate</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.currencyRate }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Note</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.paystatementnote }}</span></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                  <div>&nbsp;&nbsp;</div>
                </v-row>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th width="44%" colspan="2" style="text-align: left; border-bottom: 2px; border-bottom-style: solid;"><span style="font-size: 12pt; margin-left:10px; "><strong>Additions</strong></span></th>
                      <th v-if="isDualCurrency==true" width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">{{ secondaryCurrency }}</th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Current</th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Year to Date</th>
                      <th width="8%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in initvalue.transactions.filter(trans=>trans.transsubtype=='Addition')"  v-bind:key="trans._id">
                          <td width="2%">{{ index + 1 }}</td>
                          <td width="42%">{{ trans.transdesc }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ trans.transnote }}</td>
                          <td v-if="isDualCurrency==true" width="16%" style="text-align: right">{{ trans.transcredit2.toFixed(0) }}</td>
                          <td width="16%" style="text-align: right">{{ trans.transcredit.toFixed(2) }}</td>
                          <td width="16%" style="text-align: right">{{ ((trans.transcredit) + (initvalue.balance_ytd!==null && initvalue.balance_ytd.find(x=>x._id==trans.accountid)!==undefined ? initvalue.balance_ytd.find(x=>x._id==trans.accountid).transcredit : 0)).toFixed(2) }}</td>
                          <td width="8%">&nbsp;</td>
                        </tr>
                        <tr><td colspan="6">&nbsp;</td></tr>
                        <tr>
                          <td width="2%" style="padding-top: 5px; padding-bottom: 5px; text-align: right; border-top: 2px solid; border-bottom: 2px solid; border-left: 2px solid;"><span style="font-size: 11pt;"></span></td>
                          <td width="42%" style="padding-top: 5px; padding-bottom: 5px; text-align: right; border-top: 2px solid; border-bottom: 2px solid;"><span style="white-space:nowrap; margin-left:8px; "><strong>Gross Pay:</strong></span></td>
                          <td v-if="isDualCurrency==true" width="16%" style="padding-top: 5px; padding-bottom: 5px; text-align: right; border-top: 2px solid; border-bottom: 2px solid;"><span style="font-size: 11pt;">{{ sumAdditions2().toFixed(0) }}</span></td>
                          <td width="16%" style="padding-top: 5px; padding-bottom: 5px; text-align: right; border-top: 2px solid; border-bottom: 2px solid;"><span style="font-size: 11pt;">{{ sumAdditions().toFixed(2) }}</span></td>
                          <td width="16%" style="padding-top: 5px; padding-bottom: 5px; text-align: right; border-top: 2px solid; border-bottom: 2px solid;"><span style="font-size: 11pt;">{{ sumAdditionsYtd().toFixed(2) }}</span></td>
                          <td width="8%" style="padding-top: 5px; padding-bottom: 5px; text-align: center; border-top: 2px solid; border-bottom: 2px solid; border-right: 2px solid">{{ initvalue.primaryCurrency }}</td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th width="44%" colspan="2" style="text-align: left; border-bottom: 2px; border-bottom-style: solid;"><span style="font-size: 12pt; margin-left:10px; "><strong>Deductions</strong></span></th>
                      <th v-if="isDualCurrency==true" width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">{{ secondaryCurrency }}</th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Current</th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Year to Date</th>
                      <th width="8%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in initvalue.transactions.filter(trans=>trans.transsubtype=='Deduction')"  v-bind:key="trans._id">
                          <td width="2%">{{ index + 1 }}</td>
                          <td width="42%">{{ trans.transdesc }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ trans.transnote }}</td>
                          <td v-if="isDualCurrency==true" width="16%" style="text-align: right">{{ trans.transdebit2.toFixed(0) }}</td>
                          <td width="16%" style="text-align: right">{{ trans.transdebit.toFixed(2) }}</td>
                          <td width="16%" style="text-align: right">{{ ((trans.transdebit) + (initvalue.balance_ytd!==null && initvalue.balance_ytd.find(x=>x._id==trans.accountid)!==undefined ? initvalue.balance_ytd.find(x=>x._id==trans.accountid).transdebit : 0)).toFixed(2) }}</td>
                          <td width="8%">&nbsp;</td>
                        </tr>
                        <tr><td colspan="6">&nbsp;</td></tr>
                        <tr>
                          <td width="2%" style="padding-top: 3px; padding-bottom: 3px; border-top: 1px solid;"><span style="font-size: 11pt;"></span></td>
                          <td width="42%" style="padding-top: 3px; padding-bottom: 3px; border-top: 1px solid; text-align: right;"><span style="white-space:nowrap; margin-left:8px; "><strong>Total Deductions:</strong></span></td>
                          <td v-if="isDualCurrency==true" width="16%" style="padding-top: 3px; padding-bottom: 3px; text-align: right; border-top: 1px solid;"><span style="font-size: 11pt;">{{ sumDeductions2().toFixed(0) }}</span></td>
                          <td width="16%" style="padding-top: 3px; padding-bottom: 3px; text-align: right; border-top: 1px solid;"><span style="font-size: 11pt;">{{ sumDeductions().toFixed(2) }}</span></td>
                          <td width="16%" style="padding-top: 3px; padding-bottom: 3px; text-align: right; border-top: 1px solid;"><span style="font-size: 11pt;">{{ sumDeductionsYtd().toFixed(2) }}</span></td>
                          <td width="8%" style="padding-top: 3px; padding-bottom: 3px; text-align: right; border-top: 1px solid;">&nbsp;</td>
                        </tr>
                        <tr>
                          <td width="2%" style="padding-top: 5px; padding-bottom: 5px; border-top: 2px solid; border-bottom: 2px solid; border-left: 2px solid;"><span style="font-size: 11pt;">&nbsp;</span></td>
                          <td width="42%" style="padding-top: 5px; padding-bottom: 5px; border-top: 2px solid; border-bottom: 2px solid; text-align: right;"><span style="white-space:nowrap; margin-left:8px; "><strong>Net Pay:</strong></span></td>
                          <td v-if="isDualCurrency==true" width="16%" style="padding-top: 5px; padding-bottom: 5px; text-align: right; border-top: 2px solid; border-bottom: 2px solid;"><span style="font-size: 11pt;">{{ (sumAdditions2() - sumDeductions2()).toFixed(0) }}</span></td>
                          <td width="16%" style="padding-top: 5px; padding-bottom: 5px; text-align: right; border-top: 2px solid; border-bottom: 2px solid;"><span style="font-size: 11pt;">{{ (sumAdditions() - sumDeductions()).toFixed(2) }}</span></td>
                          <td width="16%" style="padding-top: 5px; padding-bottom: 5px; text-align: right; border-top: 2px solid; border-bottom: 2px solid;"><span style="font-size: 11pt;">{{ (sumAdditionsYtd() - sumDeductionsYtd()).toFixed(2) }}</span></td>
                          <td width="8%" style="padding-top: 5px; padding-bottom: 5px; text-align: center; border-top: 2px solid; border-bottom: 2px solid; border-right: 2px solid">{{ initvalue.primaryCurrency }}</td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th width="44%" colspan="2" style="text-align: left; border-bottom: 2px; border-bottom-style: solid;"><span style="font-size: 12pt; margin-left:10px; "><strong>Employer Contributions</strong></span></th>
                      <th v-if="isDualCurrency==true" width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">{{ secondaryCurrency }}</th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Current</th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Year to Date</th>
                      <th width="8%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in initvalue.transactions.filter(trans=>trans.transsubtype=='Contribution')"  v-bind:key="trans._id">
                          <td width="2%">{{ index + 1 }}</td>
                          <td width="42%">{{ trans.transdesc }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ trans.transnote }}</td>
                          <td v-if="isDualCurrency==true" width="16%" style="text-align: right">{{ trans.transcredit2.toFixed(0) }}</td>
                          <td width="16%" style="text-align: right">{{ trans.transcredit.toFixed(2) }}</td>
                          <td width="16%" style="text-align: right">{{ ((trans.transcredit) + (initvalue.balance_ytd!==null && initvalue.balance_ytd.find(x=>x._id==trans.accountid)!==undefined ? initvalue.balance_ytd.find(x=>x._id==trans.accountid).transcredit : 0)).toFixed(2) }}</td>
                          <td width="8%">&nbsp;</td>
                        </tr>
                        <tr><td colspan="6" style="border-bottom: 2px solid">&nbsp;</td></tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th width="44%" colspan="2" style="text-align: left; border-bottom: 2px; border-bottom-style: solid;"><span style="font-size: 12pt; margin-left:10px; "><strong>Paid Leave</strong></span></th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Increase</th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Decrease</th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Balance</th>
                      <th width="8%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody v-if="initvalue.balance_all.length>0 && initvalue.balance_all.find(trans=>trans.transsubtype=='Benefit')!=null">
                        <tr v-for="(trans, index) in initvalue.balance_all.filter(trans=>trans.transsubtype=='Benefit')"  v-bind:key="trans._id">
                          <td width="2%">{{ index + 1 }}</td>
                          <td width="42%">{{ trans.transdesc }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ getTransactionString(trans._id) }}</td>
                          <td width="16%" style="text-align: right">{{ getCreditAmountByAccount(trans._id).toFixed(2) }}</td>
                          <td width="16%" style="text-align: right">{{ getDebitAmountByAccount(trans._id).toFixed(2) }}</td>
                          <td width="16%" style="text-align: right">{{ (calculateBalanceByAccount(trans._id) + (trans.transcredit - trans.transdebit)).toFixed(2) }}</td>
                          <td width="8%">&nbsp;</td>
                        </tr>
                        <tr><td colspan="6" style="border-bottom: 2px solid">&nbsp;</td></tr>
                    </tbody>
                    <tbody v-else>
                        <tr v-for="(trans, index) in benefit_sum.filter(trans=>trans.transsubtype=='Benefit')"  v-bind:key="trans._id">
                          <td width="2%">{{ index + 1 }}</td>
                          <td width="42%">{{ trans.transdesc }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ getTransactionString(trans.accountid) }}</td>
                          <td width="16%" style="text-align: right">{{ trans.transcredit.toFixed(2) }}</td>
                          <td width="16%" style="text-align: right">{{ trans.transdebit.toFixed(2)  }}</td>
                          <td width="16%" style="text-align: right">{{ (calculateBalanceAll(trans.accountid) + (trans.transcredit - trans.transdebit)).toFixed(2) }}</td>
                          <td width="8%">&nbsp;</td>
                        </tr>
                        <tr><td colspan="6" style="border-bottom: 2px solid">&nbsp;</td></tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
                <table v-if="isHaveSaving()==true" style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th width="44%" colspan="2" style="text-align: left; border-bottom: 2px; border-bottom-style: solid;"><span style="font-size: 12pt; margin-left:10px; "><strong>Flexible Savings Account</strong></span></th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Increase</th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Decrease</th>
                      <th width="16%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Balance</th>
                      <th width="8%" style="text-align: right; border-bottom: 2px; border-bottom-style: solid">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in saving_sum"  v-bind:key="trans._id">
                          <td width="2%">{{ index + 1 }}</td>
                          <td width="42%">{{ trans.transnote }}</td>
                          <td width="16%" style="text-align: right">{{ trans.transcredit!=undefined ? trans.transcredit.toFixed(2) : '' }}</td>
                          <td width="16%" style="text-align: right">{{ trans.transdebit!=undefined ? trans.transdebit.toFixed(2) : ''  }}</td>
                          <td width="16%" style="text-align: right">{{ trans.balance.toFixed(2) }}</td>
                          <td width="8%">&nbsp;</td>
                        </tr>
                        <tr><td colspan="6" style="border-bottom: 2px solid">&nbsp;</td></tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <table style="width: 40%" cellpadding="0" cellspacing="0">
                <tr><td style="text-align: right; border-bottom: 2px; border-bottom-style: solid">Electronic document without signature</td></tr>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
  </v-app>
</template>


<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo, getServerDate } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            paystatementaddress: null,
            benefit_sum: [],
            saving_sum: [],
            logo: null,
            isDualCurrency: false,
            currencyRate: 1,
            primaryCurrency: '',
            secondaryCurrency: '',
            getServerDate: getServerDate
          };
        },
        methods: {
          ...mapActions('PayStatement', ['getPayStatementWithAppKey']),
          ...mapActions('Region', ['getRegionsRequest']),
          ...mapActions('Township', ['getTownshipsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          isHaveSaving(){
            if(this.saving_sum.length==0) return false;
            if(this.saving_sum.length==1) {
              if(this.saving_sum[0].transsubtype=='Saving' && this.saving_sum[0].balance==0) return false;
            }
            return true;
          },
          sumAdditions(){
            var list =  this.initvalue.transactions.map( trans => trans.transsubtype=='Addition' ? trans.transcredit : 0 );
            return list.reduce((a,b)=>a+b);
          },
          sumAdditions2(){
            var list =  this.initvalue.transactions.map( trans => trans.transsubtype=='Addition' ? trans.transcredit2 : 0 );
            return list.reduce((a,b)=>a+b);
          },
          sumAdditionsYtd(){
            if(this.initvalue.balance_ytd==null || this.initvalue.balance_ytd.length==0) return this.sumAdditions();
            var list =  this.initvalue.balance_ytd.map( trans => trans.transsubtype=='Addition' ? trans.transcredit : 0 );
            return this.sumAdditions() + list.reduce((a,b)=>a+b);
          },
          sumDeductions(){
            var list =  this.initvalue.transactions.map( trans => trans.transsubtype=='Deduction' ? trans.transdebit : 0  );
            return list.reduce((a,b)=>a+b);
          },
          sumDeductions2(){
            var list =  this.initvalue.transactions.map( trans => trans.transsubtype=='Deduction' ? trans.transdebit2 : 0  );
            return list.reduce((a,b)=>a+b);
          },
          sumDeductionsYtd(){
            if(this.initvalue.balance_ytd==null || this.initvalue.balance_ytd.length==0) return this.sumDeductions();
            var list =  this.initvalue.balance_ytd.map( trans => trans.transsubtype=='Deduction' ? trans.transdebit : 0 );
            return this.sumDeductions() + list.reduce((a,b)=>a+b);
          },
          sumContribution(){
            var list =  this.initvalue.transactions.map( trans => trans.transsubtype=='Contribution' ? trans.transcredit : 0  );
            return list.reduce((a,b)=>a+b);
          },
          sumContributionYtd(){
            if(this.initvalue.balance_ytd==null || this.initvalue.balance_ytd.length==0) return this.sumContribution();
            var list =  this.initvalue.balance_ytd.map( trans => trans.transsubtype=='Contribution' ? trans.transcredit : 0 );
            return this.sumContribution() + list.reduce((a,b)=>a+b);
          },
          calculateBalanceAll(accountid){
            let credit = this.initvalue.balance_all!==null && this.initvalue.balance_all.find(x=>x._id==accountid)!==undefined ? this.initvalue.balance_all.find(x=>x._id==accountid).transcredit : 0;
            let debit = this.initvalue.balance_all!==null && this.initvalue.balance_all.find(x=>x._id==accountid)!==undefined ? this.initvalue.balance_all.find(x=>x._id==accountid).transdebit : 0;
            return credit-debit;
          },
          calculateBalanceSaving(){
            let credit = this.initvalue.balance_all!==null && this.initvalue.balance_all.find(x=>x.transsubtype=='Saving')!==undefined ? this.initvalue.balance_all.find(x=>x.transsubtype=='Saving').transcredit : 0;
            let debit = this.initvalue.balance_all!==null && this.initvalue.balance_all.find(x=>x.transsubtype=='Saving')!==undefined ? this.initvalue.balance_all.find(x=>x.transsubtype=='Saving').transdebit : 0;
            return credit-debit;
          },
          calculateBalanceByAccount(accountid){
            let sum = this.initvalue.transactions.filter(trans=>trans.accountid==accountid);
            var credit_list =  sum.map( trans => trans.transcredit!==null ? trans.transcredit : 0 );
            var debit_list =  sum.map( trans => trans.transdebit!==null ? trans.transdebit : 0 );
            let credit = credit_list.length==0 ? 0 : credit_list.reduce((a,b)=>a+b);
            let debit = debit_list.length==0 ? 0 : debit_list.reduce((a,b)=>a+b);
            return credit-debit;
          },
          getCreditAmountByAccount(accountid){
            let sum = this.initvalue.transactions.filter(trans=>trans.accountid==accountid);
            var credit_list =  sum.map( trans => trans.transcredit!==null ? trans.transcredit : 0 );
            let credit = credit_list.length==0 ? 0 : credit_list.reduce((a,b)=>a+b);
            return credit;
          },
          getDebitAmountByAccount(accountid){
            let sum = this.initvalue.transactions.filter(trans=>trans.accountid==accountid);
            var debit_list =  sum.map( trans => trans.transdebit!==null ? trans.transdebit : 0 );
            let debit = debit_list.length==0 ? 0 : debit_list.reduce((a,b)=>a+b);
            return debit;
          },
          getTransactionString(accountid){
            let transactions = this.initvalue.transactions.filter(trans=>trans.accountid==accountid);
            let strings = transactions.map(trans=>trans.transnote).join(' ');
            return strings;
          },
          getBenefitSum(){
            let sum=[];
            let transactions = this.initvalue.transactions.filter(trans=>trans.transsubtype=='Benefit');
            for(var i in transactions){
              let trans = transactions[i];
              let found_account = sum.find(x=>x.accountid == trans.accountid);
              if(found_account == undefined){
                let sumcredit = this.getCreditAmountByAccount(trans.accountid);
                let sumdebit = this.getDebitAmountByAccount(trans.accountid);
                sum.push({
                  accountid: trans.accountid,
                  transcredit: sumcredit,
                  transdebit: sumdebit,
                  transdesc: trans.transdesc,
                  transnote: trans.transnote,
                  transsubtype: trans.transsubtype,
                });
              }

            }
            this.benefit_sum = sum;
          },
          getSavingSum(){
            let transactions = this.initvalue.transactions.filter(trans=>trans.transsubtype=='Saving');
            let balance = this.calculateBalanceSaving();
            let opening = {transsubtype: 'Saving', transnote: 'Opening Balance', balance: balance};
            this.saving_sum.push(opening);
            for(var i in transactions){
              let trans = transactions[i];
              balance = balance + trans.transcredit - trans.transdebit;
              trans.balance = balance;
              this.saving_sum.push(trans);
            }
          },
        },
        computed: {
          ...mapState('Region', ['regions']),
          ...mapState('Township', ['townships']),
          ...mapState('User', ['users']),
        },
        async created () {
          this.initvalue = this.$route.params;
          this.logo = getLogo(this.initvalue.companyid);  
          if(this.initvalue==undefined || this.initvalue._id == undefined || this.initvalue._id==null) {this.$router.replace({ name: 'PayStatementDocAuth' })}
          for(var i in this.initvalue.transactions){
            let trans = this.initvalue.transactions[i];
            if(this.initvalue.balance_all.find(item=>item._id==trans.accountid)==null){
              this.initvalue.balance_all.push({
                employeeid: trans.employeeid,
                transdebit: 0,
                transcredit: 0,
                transdesc: trans.transdesc,
                transsubtype: trans.transsubtype,
                _id: trans.accountid,
              });
            }
          }

          this.isDualCurrency = this.initvalue.isDualCurrency;
          this.currencyRate = this.initvalue.currencyRate;
          this.primaryCurrency = this.initvalue.primaryCurrency;
          this.secondaryCurrency = this.initvalue.secondaryCurrency;

          if(this.regions.length==0) await this.getRegionsRequest();
          if(this.townships.length==0) await this.getTownshipsRequest();
          if(this.users.length==0) await this.getUsersRequest();

          this.getBenefitSum();
          this.getSavingSum();        
        },
    };
</script>

<style src="./Print.scss" lang="scss"/>
